var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("Overview")]),_c('Doughnut',{style:(_vm.customStyles),attrs:{"chartData":_vm.chartData,"options":_vm.options,"responsive":true}}),_c('div',{staticClass:"bottom-text text-right"},[_vm._v("คิดในช่วงเวลา 18 เดือน นับย้อนจากวันปัจจุบัน")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }